import { jsx } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import { useColors, useTheme } from "@inbody/core";
import ListItem from "@mui/material/ListItem";
import { MenuItemButton } from "./MenuItemButton.js";
function LinkMenuItem(props) {
  const {
    iconNode,
    id,
    label,
    collapsed = false,
    transitioning = false,
    compact = false
  } = props;
  const { gray, base, brand } = useColors();
  const theme = useTheme();
  theme.isDarkMode;
  const { pathname } = useLocation();
  if (props.type !== "link") {
    return null;
  }
  const { url, target } = props;
  const isSelected = pathname === url;
  const buttonStyles = {
    bgcolor: "background.paper",
    margin: "2px 0",
    borderLeft: "3px solid transparent",
    color: gray[800],
    "&:hover": {
      bgcolor: gray[50],
      color: brand[500]
    },
    ...isSelected && {
      bgcolor: brand[25],
      color: brand[500],
      borderLeftColor: brand[500]
    }
  };
  return /* @__PURE__ */ jsx(ListItem, { disablePadding: true, children: /* @__PURE__ */ jsx(
    MenuItemButton,
    {
      url,
      target,
      iconNode,
      label,
      sx: buttonStyles,
      fontWeight: 500,
      collapsed,
      transitioning,
      compact
    }
  ) }, id);
}
export {
  LinkMenuItem
};
